import { Dialog, DialogType, IconButton } from '@fluentui/react';
import React, { useState, useEffect } from 'react'
import Api from '../../../services/Api'
import { ItemPicker } from '../../CreateSite/CommonComponents/ItemPicker'
import TreeComponent from '../../CreateSite/CommonComponents/TreeComponent';
import LoadingIcon from '../../formFields/LoadingIcon';


const DimensionPicker = ({itemSelector, searchTitle, searchDataUrl, treeDataUrl, rootTreeDataUrlParams, isDisabled, selection, isRequired, additionalOptions, dimensionConfig = {}, isreadonly, keyHidden, onValidation, includeCrossOrg, isMultiValue, emptyMessage, warningMessage, additionalIcon}) => {

    const [treeData, setTreeData] = useState();
    const [isDialogHidden, setIsDialogHidden] = useState(true);

    const treeDataFixedUrl = treeDataUrl.indexOf('?') > -1 ? `${treeDataUrl}&` : `${treeDataUrl}?`
    const searchDataFixedUrl = searchDataUrl.indexOf('?') > -1 ? `${searchDataUrl}&` : `${searchDataUrl}?`

    useEffect(() => {
        let isMounted = true;
        Api.get(`${treeDataFixedUrl}${includeCrossOrg ? 'includeCrossOrg=true&' : ''}${dimensionConfig.onlyChildrenAllowed ? `key=${dimensionConfig.defaultKey}&parent=all` : 'parent=abb'}`)
            .then(res => res.data)
            .then(items => {
                if (additionalOptions) {
                    items = [...additionalOptions, ...items];
                }
                if(isMounted) {
                    setTreeData(items);
                }
            });
        return () => isMounted = false;
    }, []);

    const onSelectedItem = (item) => {
        itemSelector(item)
        
        if (onValidation && isRequired)
            onValidation(isMultiValue ? !!item.length : !!item)

        if (!isMultiValue)
            setIsDialogHidden(true);
    }

    useEffect(() => {
        if (onValidation && isRequired)
            onValidation(isMultiValue ? !!selection.length : !!selection)
    }, [])
    
    const modalTree = <div>
        {   
            treeData
            ? treeData.length
                ? treeData.map(item => 
                    <TreeComponent
                        key={item.key}
                        child={item}
                        itemSelector={onSelectedItem}
                        selectedItem={selection}
                        url={treeDataUrl}
                        keyHidden={keyHidden}
                        includeCrossOrg={includeCrossOrg}
                        isMultiValue={isMultiValue}
                    />
                    )
                : emptyMessage && <div>{emptyMessage}</div>
            : <LoadingIcon />
        }
        </div>

    return (
        <div>
            <div style={{display: 'flex'}}>
                <ItemPicker
                    itemSelector={onSelectedItem}
                    searchTitle={searchTitle}
                    url={`${searchDataFixedUrl}${includeCrossOrg ? 'includeCrossOrg=true&' : ''}${dimensionConfig.onlyChildrenAllowed ? `parent=${dimensionConfig.defaultKey}&` : ''}search=`}
                    isPickerDisabled={isDisabled || dimensionConfig.isDisabled || isreadonly}
                    selection={selection}
                    isRequired={isRequired}
                    additionalOptions={additionalOptions}
                    style={{maxWidth:'calc(100% - 32px)'}}
                    keyHidden={keyHidden}
                    onValidation={onValidation}
                    isMultiValue={isMultiValue}
                    additionalIcon={additionalIcon}
                />
                <IconButton  
                    disabled={isDisabled || dimensionConfig.isDisabled || isreadonly}
                    iconProps={{
                        iconName: 'bulletedTreeList'
                    }}
                    onClick={() => setIsDialogHidden(false)}
                    styles={{root: {marginTop: searchTitle ? 40 : 0, height: 'auto'}}}
                />
                <Dialog
                    hidden={isDialogHidden}
                    onDismiss={() => setIsDialogHidden(true)}
                    modalProps={{
                        isBlocking: false
                    }}
                    dialogContentProps={{
                        type: DialogType.close
                    }}
                    minWidth={400}
                    maxWidth={600}
                >
                    {modalTree}
                </Dialog>   
            </div>
            {
                warningMessage &&
                <div className='warningMessage'>
                    { warningMessage }
                </div> 
            }
        </div>
    );
}

export default DimensionPicker


// WEBPACK FOOTER //
// ./src/components/EditSite/SiteEditElements/DimensionPicker.js